module.exports = __webpack_public_path__ + "static/media/microphone-stop.09d0b6c2.svg";